import { FieldNames } from 'Constants/FieldNames'
import { BaseItem } from 'Types/item'
import { SberGeoUnitParamsKeys } from 'Pages/orders_design'

export const UPLOAD_FILE_TYPE =
	'.jpeg, .pdf, .jpg, .png, .tiff, .tif, .jpeg, .pptx, .xls, .xlsx, .doc, .docx, .zip, .rar'
export const rateValidateOptions = {
	min: 1.6,
	max: 2.5,
}

export const terminalData = {
	IKR: {
		id: 3,
		name: 'Интегрированный',
		commission: 'от 1.3%',
		info:
			'Такой терминал подключается непосредственно к кассе, сумму вводить не нужно. Чаще всего используется в ' +
			'супермаркетах и других точках, где касса физически расположена в месте расчета с покупателем.',
	},
	POS_KEY: {
		id: 1,
		name: 'Стационарный',
		commission: 'от 1.3%',
		info:
			'Терминал не подключается к кассе, поэтому сумму нужно вводить вручную. К терминалу ' +
			'подключена выносная клавиатура, (пинпад) которую удобно повернуть к клиенту. Хорошо подходит торговым точкам, ' +
			'в которых касса расположена отдельно от места расчета с покупателем.',
	},
	POS_NO_KEY: {
		id: 2,
		name: 'Переносной',
		commission: 'от 1.3%',
		info:
			'Работает от аккумулятора и не требует постоянного подключения к электросети. Терминал не подключается к ' +
			'кассе, поэтому сумму нужно вводить вручную. Обычно используется в ресторанах и службами доставки.',
	},
	EVOTOR: {
		id: 5,
		name: 'Эвотор 7.3',
		commission: 'от 1.3%',
		info:
			'Онлайн-касса с подключенным терминалом эквайринга. Может работать от аккумулятора, ' +
			'но больше подходит для стационарного использования.',
	},
	SMART_POS: {
		id: 4,
		name: 'Эвотор 5i',
		commission: 'от 1.3%',
		info:
			'Мобильная касса с эквайрингом для малого и микробизнеса. Идеальна для курьерской доставки, ' +
			'торговли на выезде, в небольших магазинах и на рынках',
	},
} as const

export enum ProductCardOptions {
	RAR = 'rar',
	WVB = 'wvb',
}

export const optionMap = {
	[ProductCardOptions.RAR]: 'Резервирование счёта',
	[ProductCardOptions.WVB]: 'Без визита в банк',
}
export enum NavListItemKey {
	COMMON_INFO = 'commonInfo',
	REASSIGN = 'reassign',
	TRADING_EQUARING = 'tradingEquaring',
}

export const leadValues = [
	FieldNames.LAST_NAME,
	FieldNames.FIRST_NAME,
	FieldNames.MIDDLE_NAME,
	FieldNames.PHONE,
	FieldNames.EMAIL,
]

export const DEFAULT_MAX_COUNT_FILES = 3
export const DECISION_MAKER_PERSON = 'decision_maker_person'
export const MANAGER = 'manager'

export const merchantParams = 'with_merchant_branches: 1'

export const LegalAge = {
	OOO: 18,
	IP: 16,
}

export enum visitType {
	OUT_OFFICE_VISIT = '1',
}

export const visitFlagSelectItems: BaseItem[] = [
	{ id: '0', name: 'В офисе банка' },
	{ id: '1', name: 'Выездной менеджер' },
]

enum requiredAddressesType {
	WITH_MANAGER = 'with_manager',
	SBER_MQ_REGION_ID = 'sber_mq_region_id',
}

export const requiredAddressesParams: SberGeoUnitParamsKeys[] = [
	requiredAddressesType.WITH_MANAGER,
	requiredAddressesType.SBER_MQ_REGION_ID,
]

export const FAILED_APPOINTMENT_MESSAGE = 'Not found active slots'

export const OUTOFFICEFLAG = 1

export const FAILED_STATUS = 'ERROR'
export const SUCCESS_STATUS = 'SUCCESS'

export enum FAILED_MESSAGE {
	NO_SLOTS = 'Not found active slots from :data to :data in :data',
}

export const errorsPosaddress = [
	'posaddress_house',
	'posaddress_house_type_full',
	'posaddress_postal_code',
	'posaddress_street',
	'posaddress_street_type_full',
]
export const E404_CODE = 404
export const E403_CODE = 403

export enum ErrorAppointmentCode {
	e403 = 403,
	e503 = 503,
	e404 = 404,
}

export const FORM_ERROR = {
	[ErrorAppointmentCode.e404]: FieldNames.ADDRESS_DADATA,
}

export const FORM_ERROR_TEXT = {
	[ErrorAppointmentCode.e404]:
		'Место встречи находится вне зоны выездного менеджера. Введите другой адрес',
}

export const SECOND_LIMIT = 600

export enum APPOINTMENT_ERROR {
	NO_PHONE = 'Found active entry with this phone',
	NO_TICKETS = 'Not found ticket',
}

export const ERROR_TAG = {
	[APPOINTMENT_ERROR.NO_PHONE]: '0',
	[APPOINTMENT_ERROR.NO_TICKETS]: '1',
}

export const tooltipAddress = `Введите адрес размещения, кроме Республики Крым, Севастополя и Байконура. 
Адрес должен заполняться до уровня дома.`

export const fieldsForRequest = (fields: { [key in keyof FieldNames]?: any }): string[] => {
	return Object.keys(fields)
}

export const TEXT_CHANGE_CM_VISITFlAG =
	'Рекомендуем изменить способ оформления документов на офис банка'
